{
  "companyName": "Mezmo",
  "search": "Search...",
  "save": "Save",
  "saveAndNext": "Save and next",
  "apply": "Apply",
  "cancel": "Cancel",
  "edit": "Edit",
  "delete": "Delete",
  "yes": "Yes",
  "yesDelete": "Yes, delete",
  "no": "No",
  "selectAll": "Select all",
  "deselectAll": "Deselect all",
  "showMore": "show more…",
  "moreInfo": "More info…",
  "instructions": "Instructions",
  "today": "Today",
  "test": "Test",
  "type": "Type",
  "in": "in",
  "line": "Line",
  "line_plural": "Lines",
  "utc": "UTC",
  "add": "Add",
  "addItem": "Add item",
  "replace": "Replace",
  "refresh": "Refresh",
  "sortedAscending": "Sorted ascending",
  "sortedDescending": "Sorted descending",
  "error": "Error",
  "or": "or",
  "defaultRequestError": "An error occurred while processing your request.",
  "default": "default",
  "custom": "Custom",
  "success": "Success",
  "close": "Close",
  "tooltip": "Tooltip",
  "remove": "Remove",
  "accessError": "You don't have sufficient permissions to access this page.",
  "insufficientPermissions": "You don't have the required permissions to perform this action",
  "from": "From",
  "to": "To",
  "filters": "Filters",
  "and": "and",
  "chooseFile": "Choose file",
  "validation": {
    "cannotBeEmpty": "{{ field }} cannot be empty",
    "invalidFormat": "{{ field }} is invalid",
    "invalidURI": "{{ field }} should be a valid URL",
    "minLength": "Should be at least {{ length }} characters",
    "maxLength": "Should be less than {{ length }} characters",
    "invalidCharacters": "Value contains invalid characters"
  },
  "clear": "Clear",
  "required": "Required",
  "create": "Create",
  "created": "Created",
  "confirm": "Confirm",
  "downgrade": "Downgrade",
  "upgrade": "Upgrade",
  "update": "Update",
  "hipaa": "HIPAA",
  "download": "Download",
  "csv": "CSV",
  "json": "JSON",
  "next": "Next",
  "previous": "Previous",
  "back": "Back",
  "selectDateRange": "Select a date range",
  "ok": "OK",
  "submit": "Submit",
  "copy": "Copy",
  "copied": "Copied to clipboard",
  "backTo": "Back to {{ title }}",
  "reset": "Reset",
  "more": "More",
  "less": "Less",
  "disabled": "Disabled",
  "retry": "Retry",
  "view": "View",
  "continue": "Continue",
  "pager": {
    "previous": "Previous",
    "next": "Next",
    "pageOf": "Page {{page}} of {{pages}}"
  }
}
